import $ from './jquery-1.11.3.min';
import Inputmask from './inputmask';
window.Inputmask = Inputmask;
window.$ = $;
require('./inputmask');
require('./publish');
